module.exports = __webpack_public_path__ + "img/product-1-back.3fdbbe66.png";